import React from 'react';
import PropTypes from 'prop-types';
import styles from './RemoveButton.scss';

const RemoveButton = ({ onClick, insideForm, className, closeLabel }) => (
  <button 
    onClick={onClick} 
    type="button" 
    className={`${className} close ${insideForm ? styles.insideForm : styles.normal}`}
    aria-label="Close"
  >
    <span className={styles.closeLabel}>{closeLabel}</span>
    <span className="align-middle">&times;</span>
  </button>
);

RemoveButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  insideForm: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string
};

RemoveButton.defaultProps = {
  insideForm: false,
  className: '',
};

export default RemoveButton;


// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/RemoveButton.jsx